module.exports = __webpack_public_path__ + "static/organic-search-row-six-hero-2-4056f14add5ed2f4493c8da3271761a5.png";